import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SchemaProvider } from "@/context/SchemaContext";
import LockScreen from "@/pages/LockScreen";
import Shell from "@/components/layout/Shell";
import AgentHome from "@/pages/AgentHome";
import FactoryPage from "@/pages/FactoryPage";
import Reports from "@/pages/admin/Reports";
import Vault from "@/pages/admin/Vault";
import Contracts from "@/pages/admin/Contracts";
import SettingsPage from "@/pages/admin/Settings";
import ShellPage from "@/pages/ShellPage";
import WorkMonitor from "@/pages/WorkMonitor";
import FactoriesOverview from "@/pages/FactoriesOverview";

function Gate() {
  const { session } = useAuth();
  if (session === undefined) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-2 border-cyan-400/30 border-t-cyan-400 animate-spin" />
      </div>
    );
  }
  if (!session) return <LockScreen />;
  return (
    <SchemaProvider>
      <Routes>
        <Route element={<Shell />}>
          <Route path="/" element={<AgentHome />} />
          <Route path="/shell" element={<ShellPage />} />
          <Route path="/work" element={<WorkMonitor />} />
          <Route path="/factories" element={<FactoriesOverview />} />
          <Route path="/factory/:fid" element={<FactoryPage />} />
          <Route path="/admin/reports" element={<Reports />} />
          <Route path="/admin/vault" element={<Vault />} />
          <Route path="/admin/contracts" element={<Contracts />} />
          <Route path="/admin/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </SchemaProvider>
  );
}

export default function App() {
  return (
    <div className="App" dir="rtl">
      <AuthProvider>
        <BrowserRouter>
          <Gate />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-left" richColors theme="dark" toastOptions={{ style: { background: "#0F172A", border: "1px solid rgba(255,255,255,0.1)", color: "#F8FAFC", fontFamily: "inherit" } }} />
    </div>
  );
}
